export default __webpack_public_path__ + "static/media/Alyssa 9781408339558.06d3c90c.jpg";